import getSupportedLocale from "../../helpers/getSupportedLocale"
import env from "../../../env"
import {getLocaleUrl} from "../../../links"

export default function getUrl(bucketName: string, rawLocale: string) {
  const locale = getSupportedLocale(rawLocale)
  return `${getLocaleUrl()}/locale/web/${locale}/${bucketName}.json?${env.BUNDLE_REF}`.toLowerCase()
}
